import React from "react";
import { getColors } from "../../utils/constants";

import style from "./queue.module.scss";

const classNames = (stage) => {
  switch (stage) {
    case 1:
      return style.enter;
    case 2:
      return style.exit;
    case 0:
    default:
      return "";
  }
};

export const Queue = ({ stage, data = [] }) => {
  return (<div className={style.wrapper}>
      <div className={`${style.container}`}>
          {data.map((item: any, i) => {
            const { orderNumber, priority } = item;
            if (!i) return (<h3 style={{ color: getColors(priority)}} key={i} className={`${style.firstitem} ${classNames(stage)}`}> {orderNumber} </h3>);
            if (i >= 4) return (<h3 style={{ color: getColors(priority)}} key={i} className={`${style.lastitem} ${classNames(stage)}`}> {orderNumber} </h3>);
            return (<h3 style={{ color: getColors(priority)}} key={i}> {orderNumber} </h3>);
          })}
      </div>
  </div>);
};
